import { apiFloristGatewayService, apiGatewayService } from './apiService/HttpService';
import { setEndPoint } from './apiService/SetEndPoint';
import { endPoints } from './apiService/EndPoints';

class FloristAssignmentService {
  /**
   * Orders a florist dropped that are waiting for someone to take them. Lives on the
   * hub service, so it goes through the plain gateway with the opsId header the
   * interceptor already adds.
   */
  static getDroppedOrders(params) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.assignmentDroppedOrders),
      params,
    });
  }

  /**
   * Florists in the caller's OPS scope with skill, online status and current load.
   */
  static getFlorists(params) {
    return apiGatewayService({
      method: 'GET',
      url: setEndPoint(endPoints.assignmentFlorists),
      params,
    });
  }

  /**
   * Hand a dropped order to a florist. targetFloristId null means the caller takes it.
   */
  static reassignOrder(orderId, data) {
    return apiFloristGatewayService({
      method: 'PUT',
      url: setEndPoint(endPoints.orderReassignments, orderId),
      data,
    });
  }
}

export default FloristAssignmentService;
